import { render, staticRenderFns } from "./diybanner.vue?vue&type=template&id=161ed3ae&scoped=true&"
import script from "./diybanner.vue?vue&type=script&lang=js&"
export * from "./diybanner.vue?vue&type=script&lang=js&"
import style0 from "./diybanner.vue?vue&type=style&index=0&id=161ed3ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161ed3ae",
  null
  
)

export default component.exports